import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';

export const getters: GetterTree<RootState, RootState> = {
    /**
     * Check if the permission is enabled.
     *
     * @param state
     */
    permissionEnabled: (state, myGetters) => (key: string): boolean => {
        if (myGetters.loggedUserAdmin) { return true; }
        const permission = state.permissions.find((item) => item.name === key);
        return permission ? true : false;
    },

    /**
     * Return the specified calendar.
     *
     * @param state
     */
    getPreferenceByKey: (state) => (key: string) => {
        const preference = state.preferences.find((item) => item.key === key);
        return preference ? preference.value : undefined;
    },

    /**
     * Return the specified setting.
     *
     * @param state
     */
    getSettingByKey: (state) => (key: string) => {
        const setting = state.settings.find((item) => item.key === key);
        return setting ? setting.value : undefined;
    },
    
    /**
     * Check if tenant was identified.
     * @param state
     */
    tenantIdentified: (state) => !!state.tenant,

    /**
     * Check if logged user is an admin.
     * @param state
     */
    loggedUserAdmin: (state) => !!state.user && state.user.role === 'admin',

    /**
     * Check if user has associated users.
     * @param state
     */
    isLoggedUserTeamLeader: (state) => {
        return !!state.user && state.user.relationships && state.user.relationships.length > 0;
    }
};
